import React from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItem, ListItemText, Paper, Typography } from '@mui/material';

import { mailPlaceholders } from '../BulkMailInterfaces';

const EmailPlaceholderList: React.FC = () => {
  const { t } = useTranslation(['recruiter']);
  return (
    <Paper style={{ backgroundColor: '#F8F8F9' }} elevation={0} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom style={{ fontWeight: 500 }}>
        {t('recruiter:GENERAL.MAILS.placeholders.topHeading')}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {t('recruiter:GENERAL.MAILS.placeholders.info')}
      </Typography>
      <List>
        {mailPlaceholders.map((item) => (
          <ListItem key={item.key} disablePadding>
            <ListItemText primary={item.key} secondary={t(`recruiter:GENERAL.MAILS.placeholders.${item.desc}`)} />
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default EmailPlaceholderList;
